import { UploadOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Space,
  Spin,
} from "antd";
import axios from "axios";
import heic2any from "heic2any";
import Cookies from "js-cookie";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { GreenButton } from "../../components/button/GreenButton";
import { GuestLayout } from "../../components/layout/guest-layout";
import "./add_purchase.css";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
});

export const POST = async (path, data, header) => {
  const config = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };
  try {
    const response = await instance.post(
      `/${path}`,
      data,
      header ? header : config,
    );
    data = await response.data;
    return data;
  } catch (error) {
    throw error.response;
  }
};

export const GET = async (path, header) => {
  // Set default headers with Authorization token
  const defaultConfig = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };

  // Merge custom headers if provided
  const config = header ? { ...defaultConfig, ...header } : defaultConfig;

  try {
    // Perform GET request
    const response = await instance.get(path, config);
    const data = response.data;
    return data;
  } catch (error) {
    // Log error response
    console.log(error.response);
    throw error.response;
  }
};

export const PATCH = async (path, data) => {
  const config = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };
  try {
    const response = await instance.patch(`${path}`, data, config);
    data = await response.data;
    return data;
  } catch (error) {
    console.log(error.response);
    throw error.response;
  }
};

export default function AddPurchase() {
  const { phone_cust } = useParams();
  const [pdpa, setpdpa] = useState(true);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState({}); // Initial state for other values
  const [imgFile, setImgFile] = useState(false);
  const [Ordernumber, setOrdernumber] = useState("");
  const [foundorder, setFoundorder] = useState(false);
  const [findorder, setFindorder] = useState(false);
  const [form] = Form.useForm();
  const [openModal, setOpenModal] = useState(false);
  const [countdown, setCountdown] = useState(5);

  const mode = new URLSearchParams(window.location.search).get("mode");

  useEffect(() => {
    if (Cookies.get("phone") != phone_cust) {
      Cookies.remove("jwt");
      Cookies.remove("phone");
      window.location = "/register-warranty/login";
    }
  }, []);

  const [loadings, setLoadings] = useState([]);
  const enterLoading = (index) => {
    setLoadings((prevLoadings) => {
      const newLoadings = [...prevLoadings];
      newLoadings[index] = true;
      return newLoadings;
    });
    setTimeout(() => {
      setLoadings((prevLoadings) => {
        const newLoadings = [...prevLoadings];
        newLoadings[index] = false;
        return newLoadings;
      });
    }, 15000);
  };

  const [pathphoto, setpathphoto] = useState("");
  const [formValue, setformValue] = useState({
    cust_phone_number: phone_cust,
    purc_channel: "",
    purc_receipt_photo: "",
    purc_receipt_id: "",
    consent_pdpa: "",
    purc_date: "",
  });

  const [fileList, setFileList] = useState([]);

  const props = {
    fileList,
    onChange: ({ fileList: newFileList }) => {
      setFileList(newFileList);
    },
    multiple: false,
    maxCount: 1,
    accept:
      "image/png, image/jpeg, image/jpg, image/gif, image/heif, image/heic, .png, .jpeg, .jpg, .gif, .heif, .heic, .PNG, .JPEG, .JPG, .GIF, .HEIF, .HEIC",
  };

  document.addEventListener("DOMContentLoaded", function () {
    const upload = document.querySelector("#upload");

    function addNewImage(img) {
      const newImage = new Image();
      newImage.src = img;

      newImage.onload = () => {
        const canvas = document.createElement("canvas");
        const maxDimension = 1000;
        let width = newImage.width;
        let height = newImage.height;

        if (width > maxDimension || height > maxDimension) {
          if (width > height) {
            height *= maxDimension / width;
            width = maxDimension;
          } else {
            width *= maxDimension / height;
            height = maxDimension;
          }
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(newImage, 0, 0, width, height);

        const resizedDataURL = canvas.toDataURL("image/jpeg");
        setpathphoto(resizedDataURL);
        setformValue({
          ...formValue,
          purc_receipt_photo: resizedDataURL,
        });
      };
    }

    function uploadHandler(e) {
      const files = e.target.files;
      console.error("test");

      if (files?.length) {
        const file = files[0];
        setImgFile(true);
        setLoading(true);
        if (
          file.type.toLowerCase() === "image/heic" ||
          file.name.toLowerCase().includes(".heic") ||
          file.type.toLowerCase() === "image/heif" ||
          file.name.toLowerCase().includes(".heif")
        ) {
          heic2any({ blob: file, toType: "image/jpg", quality: 0.8 }).then(
            (newImage) => {
              const url = URL.createObjectURL(newImage);
              addNewImage(url);
              setLoading(false);
            },
          );
        } else {
          const url = URL.createObjectURL(file);
          addNewImage(url);
          setLoading(false);
        }
      } else {
        console.error("No file specified");
      }
    }

    if (upload) {
      upload.addEventListener("change", uploadHandler);
    } else {
      console.error("Element with id 'upload' not found.");
    }
  });

  useEffect(() => {
    if (!openModal) return;

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          window.location = "https://bewellofficial.com/register-warranty";
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [openModal]);

  const handleSubmit = async (e) => {
    try {
      const patternbes = /^[A-Z]{2}[0-9]{14}$/;
      if (formValue.purc_receipt_photo === "") {
        message.open({
          type: "error",
          content: "กรุณาอัปโหลดหลักฐาน",
          style: {
            marginTop: "8vh",
            fontSize: "16px",
          },
        });
      } else if (formValue.purc_receipt_id === "") {
        message.open({
          type: "error",
          content: "กรุณากรอกเลขคำสั่งซื้อ",
          style: {
            marginTop: "8vh",
            fontSize: "16px",
          },
        });
      } else if (formValue.purc_channel === "") {
        message.open({
          type: "error",
          content: "กรุณาเลือกช่องทางการซื้อสินค้า",
          style: {
            marginTop: "8vh",
            fontSize: "16px",
          },
        });
      } else if (formValue.purc_date === "") {
        message.open({
          type: "error",
          content: "กรุณากรอกวันที่ซื้อสินค้า",
          style: {
            marginTop: "8vh",
            fontSize: "16px",
          },
        });
      } else if (formValue.consent_pdpa === "0") {
        message.open({
          type: "warning",
          content: "ยินยอมให้เก็บข้อมูลหรือไม่",
          style: {
            marginTop: "8vh",
            fontSize: "16px",
          },
        });
      } else if (formValue.purc_channel === "bes") {
        if (patternbes.test(formValue.purc_receipt_id)) {
          const checkorder = await POST("check_order_num/", {
            order_number: formValue.purc_receipt_id,
            cust_phone_number: formValue.cust_phone_number,
          });
          if (checkorder === false) {
            enterLoading(0);
            message.open({
              type: "loading",
              content: "กรุณารอสักครู่",
              style: {
                marginTop: "8vh",
                fontSize: "16px",
              },
            });
            const addorder = await POST("add_purchase/", formValue);
            message.open({
              type: "success",
              content: "บันทึกสำเร็จ",
              style: {
                marginTop: "8vh",
                fontSize: "16px",
              },
            });
            window.location = `/register-warranty/order_list/${phone_cust}`;
          } else {
            message.open({
              type: "error",
              content: "มีเลขคำสั่งซื้อนี้อยู่ในระบบแล้ว",
              style: {
                marginTop: "8vh",
                fontSize: "16px",
              },
            });
          }
        } else {
          message.open({
            type: "error",
            content: "เลขคำสั่งซื้อไม่ถูกต้อง",
            style: {
              marginTop: "8vh",
              fontSize: "16px",
            },
          });
        }
      } else {
        const checkorder = await POST("check_order_num/", {
          order_number: formValue.purc_receipt_id,
          cust_phone_number: formValue.cust_phone_number,
        });
        if (checkorder === false) {
          enterLoading(0);
          message.open({
            type: "loading",
            content: "กรุณารอสักครู่",
            style: {
              marginTop: "8vh",
              fontSize: "16px",
            },
          });
          const addorder = await POST("add_purchase/", formValue);
          message.open({
            type: "success",
            content: "บันทึกสำเร็จ",
            style: {
              marginTop: "8vh",
              fontSize: "16px",
            },
          });
          window.location = `/register-warranty/order_list/${phone_cust}`;
        } else {
          message.open({
            type: "error",
            content: "มีเลขคำสั่งซื้อนี้อยู่ในระบบแล้ว",
            style: {
              marginTop: "8vh",
              fontSize: "16px",
            },
          });
        }
      }
    } catch (error) {
      console.error(error);
      message.open({
        type: "error",
        content: "เกิดข้อผิดพลาดบางอย่างขึ้น โปรดลองอีกครั้งในภายหลัง",
        style: {
          marginTop: "8vh",
          fontSize: "16px",
        },
      });
    }
  };

  const datainputChange = (e) => {
    setOrdernumber(e);
    setformValue({
      ...formValue,
      purc_receipt_id: e.target.value,
    });
  };

  const datainputselect = (e) => {
    setformValue({
      ...formValue,
      purc_channel: e,
    });
  };

  useEffect(() => {
    if (pdpa == true) {
      setformValue({
        ...formValue,
        consent_pdpa: "1",
      });
    } else {
      setformValue({
        ...formValue,
        consent_pdpa: "0",
      });
    }
  }, [pdpa]);

  const handleDateChange = (date, dateString) => {
    setformValue({
      ...formValue,
      purc_date: dateString, // dateString is the formatted date string
    });
  };

  const fileInputRef = useRef(null);

  const openFileInput = () => {
    fileInputRef.current.click();
  };

  const [selectedFileName, setSelectedFileName] = useState("");

  const handleFileInputChange = (e) => {
    const files = e.target.files;
    console.error("test");

    if (files?.length) {
      const file = files[0];
      setSelectedFileName(file.name);
      setImgFile(true);
      setLoading(true);
      if (
        file.type.toLowerCase() === "image/heic" ||
        file.name.toLowerCase().includes(".heic") ||
        file.type.toLowerCase() === "image/heif" ||
        file.name.toLowerCase().includes(".heif")
      ) {
        heic2any({ blob: file, toType: "image/jpg", quality: 0.8 }).then(
          (newImage) => {
            const url = URL.createObjectURL(newImage);
            addNewImage(url);
            setLoading(false);
          },
        );
      } else {
        const url = URL.createObjectURL(file);
        addNewImage(url);
        setLoading(false);
      }
    } else {
      console.error("No file specified");
    }
  };

  const addNewImage = (img) => {
    const newImage = new Image();
    newImage.src = img;

    newImage.onload = () => {
      const canvas = document.createElement("canvas");
      const maxDimension = 1000;
      let width = newImage.width;
      let height = newImage.height;

      if (width > maxDimension || height > maxDimension) {
        if (width > height) {
          height *= maxDimension / width;
          width = maxDimension;
        } else {
          width *= maxDimension / height;
          height = maxDimension;
        }
      }

      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext("2d");
      ctx?.drawImage(newImage, 0, 0, width, height);

      const resizedDataURL = canvas.toDataURL("image/jpeg");
      setpathphoto(resizedDataURL);
      setformValue({
        ...formValue,
        purc_receipt_photo: resizedDataURL,
      });
    };
  };

  useEffect(() => {
    const upload = fileInputRef.current;
    if (upload) {
      upload.addEventListener("change", handleFileInputChange);
    } else {
      console.error("Element with id 'upload' not found.");
    }

    return () => {
      if (upload) {
        upload.removeEventListener("change", handleFileInputChange);
      }
    };
  }, []);

  const checksku = async () => {
    if (Ordernumber !== "") {
      try {
        const checkorder = await GET(
          `check_order_num_exist/${formValue.purc_receipt_id}`,
        );
        console.log(checkorder);
        setFoundorder(checkorder);
        setFindorder(true);
        if (checkorder === true) {
          message.success(`พบเลขคำสั่งซื้อในระบบ`);
        } else {
          message.error(`ไม่พบเลขคำสั่งซื้อ กรุณากรอกรายละเอียด`);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  const onFinish = async (values) => {
    const { CustFullname } = values;
    const { OrderNumber } = values;
    const { purc_channel } = values;
    const { purc_date } = values;
    const purchaseValue = {
      ...value,
      CustPhoneNumber: phone_cust,
      OrderNumber: OrderNumber,
      consent_pdpa: pdpa === true ? "1" : "0",
      purc_channel: purc_channel,
      purc_date: purc_date,
      purc_receipt_photo: pathphoto,
    };
    const updateValueCustPhone = {
      CustPhoneNumber: phone_cust,
      CustFullname: CustFullname,
      OrderNumber: OrderNumber,
    };
    if (findorder === false) {
      message.warning(`กรุณาเช็คเลขออเดอร์กับระบบ`);
    } else {
      try {
        if (foundorder === true) {
          await PATCH("update_customer_name_phone/", updateValueCustPhone);
        } else {
          await POST("add_purchase/", purchaseValue);
        }
        message.open({
          type: "success",
          content: "บันทึกสำเร็จ",
          style: {
            marginTop: "8vh",
            fontSize: "16px",
          },
        });
        if (mode === "website") {
          setOpenModal(true);
        } else {
          window.location = `/register-warranty/order_list/${phone_cust}`;
        }
      } catch (error) {
        message.open({
          type: "error",
          content: "พบข้อผิดพลาด",
          style: {
            marginTop: "8vh",
            fontSize: "16px",
          },
        });
      }
    }
  };

  return (
    <GuestLayout title={"ลงทะเบียนรับประกันสินค้า Warranty Registration"}>
      <div className="textinput">
        <div className="subtextinput">
          <div className="title">
            <h2>
              ลงทะเบียนรับประกันสินค้า<br></br>Warranty Registration
            </h2>
          </div>
          <Form
            layout="vertical"
            className="Form"
            onFinish={onFinish}
            form={form}
          >
            <Form.Item
              rules={[{ required: true, message: "กรุณากรอกเลขที่คำสั่งซื้อ" }]}
              label="เลขที่คำสั่งซื้อ (Order ID)"
              name="OrderNumber"
            >
              <Row gutter={10}>
                <Col span={18}>
                  <Input
                    placeholder="เลขที่คำสั่งซื้อ"
                    value={formValue.ordernumber}
                    onChange={datainputChange}
                    name="OrderNumber"
                    disabled={loading == true}
                  />
                </Col>
                <Col span={6}>
                  <Button onClick={checksku}>check order</Button>
                </Col>
              </Row>
            </Form.Item>
            {foundorder && findorder && (
              <>
                <Form.Item
                  rules={[
                    { required: true, message: "กรุณากรอก ชื่อ-นามสกุล" },
                  ]}
                  label="ชื่อ-นามสกุล (Full name)"
                  name="CustFullname"
                >
                  <Input placeholder="ชื่อ-นามสกุล" />
                </Form.Item>
                <Form.Item
                  rules={[
                    { required: true, message: "กรุณากรอกเบอร์โทรศัพท์" },
                  ]}
                  label="เบอร์โทรศัพท์ (Phone Number)"
                  name="CustPhoneNumber"
                >
                  <Input placeholder="เบอร์โทรศัพท์" />
                </Form.Item>
              </>
            )}

            {!foundorder && findorder && (
              <>
                <Form.Item
                  name="purc_channel"
                  rules={[
                    {
                      required: true,
                      message: "กรุณาเลือก ช่องทางการซื้อสินค้า",
                    },
                  ]}
                  label="ช่องทางการซื้อสินค้า (Channel)"
                >
                  <Select
                    value={form.getFieldValue("channel")}
                    name="purc_channel"
                    onChange={datainputselect}
                    placeholder="เลือกช่องทางที่ซื้อ"
                    showSearch
                    disabled={loading}
                  >
                    <Select.Option value="b2s">B2S</Select.Option>
                    <Select.Option value="banana">Banana IT</Select.Option>
                    <Select.Option value="betrend">BeTrend</Select.Option>
                    <Select.Option value="bes">
                      Bewell Ergonomic Space
                    </Select.Option>
                    <Select.Option value="homepro">Homepro</Select.Option>
                    <Select.Option value="lazada">Lazada</Select.Option>
                    <Select.Option value="loft">Loft</Select.Option>
                    <Select.Option value="medium_and_more">
                      Medium and More
                    </Select.Option>
                    <Select.Option value="mercular">Mercular</Select.Option>
                    <Select.Option value="nocnoc">NocNoc</Select.Option>
                    <Select.Option value="powerbuy">Powerbuy</Select.Option>
                    <Select.Option value="sb">SB Design Square</Select.Option>
                    <Select.Option value="se_ed">
                      SE-ED Book Center
                    </Select.Option>
                    <Select.Option value="shopee">Shopee</Select.Option>
                    <Select.Option value="tiktok">TikTok</Select.Option>
                    <Select.Option value="website">Website</Select.Option>
                    <Select.Option value="zeenzone">ZeenZone</Select.Option>
                    <Select.Option value="commart">งาน Commart</Select.Option>
                    <Select.Option value="baanlaesuan">
                      งานบ้านและสวนแฟร์
                    </Select.Option>
                    <Select.Option value="events">
                      งาน Event อื่น ๆ
                    </Select.Option>
                    <Select.Option value="others">ช่องทางอื่น ๆ</Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  rules={[
                    { required: true, message: "กรุณากรอกวันที่ซื้อสินค้า" },
                  ]}
                  label="วันที่ซื้อสินค้า (Purchase Date)"
                  name="purc_date"
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    allowClear
                    format={"YYYY-MM-DD"}
                    value={moment(formValue.purc_date)} // Convert date to moment object
                    onChange={(date, dateString) =>
                      handleDateChange(date, dateString)
                    }
                    disabled={loading == true}
                  />
                </Form.Item>

                <Form.Item
                  rules={[{ required: true, message: "กรุณา upload รูป" }]}
                  label="ภาพถ่ายใบเสร็จ/หน้าจอคำสั่งซื้อ (Receipt Photo/Order Screenshot) ไฟล์ชนิด png หรือ jpg เท่านั้น"
                >
                  <div id="app">
                    <input
                      ref={fileInputRef}
                      id="upload"
                      {...props}
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleFileInputChange}
                    />
                    <Space>
                      <Button icon={<UploadOutlined />} onClick={openFileInput}>
                        Upload
                      </Button>
                      {selectedFileName && <span>{selectedFileName}</span>}
                    </Space>
                  </div>
                  {loading ? (
                    <Space>
                      <Spin /> Please wait
                    </Space>
                  ) : form.getFieldValue("receipt_photo") ? (
                    "Success"
                  ) : null}
                </Form.Item>
              </>
            )}
            <Form.Item>
              <Checkbox
                checked={pdpa}
                onChange={(e) => setpdpa(e.target.checked)}
              >
                ยินยอมให้เก็บข้อมูลของท่านเพื่อใช้ตามวัตถุประสงค์ในการให้บริการของเรา
                ภายใต้{" "}
                <a
                  href="https://www.bewellofficial.com/term-and-conditions/"
                  target="_blank"
                >
                  ข้อตกลงและเงื่อนไข
                </a>{" "}
                และ{" "}
                <a
                  href="https://www.bewellofficial.com/privacy-policy/"
                  target="_blank"
                >
                  นโยบายความเป็นส่วนตัว
                </a>
              </Checkbox>
            </Form.Item>
            {findorder && (
              <Form.Item>
                <GreenButton block htmlType="submit" loading={loadings[0]}>
                  ส่งข้อมูล
                </GreenButton>
              </Form.Item>
            )}
          </Form>
        </div>
        <Modal open={openModal} footer={null} closable={false} centered>
          <div style={{ textAlign: "center" }}>
            <h2>บันทึกสำเร็จ 🎉</h2>

            <p>กำลังกลับสู่หน้าหลักใน {countdown} วินาที</p>

            <Button
              type="primary"
              onClick={() => {
                window.location =
                  "https://bewellofficial.com/register-warranty";
              }}
            >
              กลับสู่หน้าหลัก
            </Button>
          </div>
        </Modal>
      </div>
    </GuestLayout>
  );
}
